import { IonCol, IonContent, IonPage, IonRow } from "@ionic/react";
import { ReactNode } from "react";

import { PageLogo } from "../../../components/images/Logo";
import "./LoginRegister.css";

function LogRegHeader({
  title,
  subHeader,
}: {
  title: string | ReactNode;
  subHeader?: string | ReactNode;
}) {
  return (
    <>
      <IonRow className="ion-justify-content-center">
        <IonCol className="ion-text-center">
          <h2>{title}</h2>
        </IonCol>
      </IonRow>
      {subHeader ? (
        <IonRow className="content-sub-block ion-justify-content-center">
          <IonCol className="shrink ion-text-center">{subHeader}</IonCol>
        </IonRow>
      ) : null}
    </>
  );
}

function LogRegPageLayout({ children }: { children: ReactNode }) {
  return (
    <IonPage>
      <IonContent fullscreen>
        <IonRow className="ion-justify-content-center full-row">
          <IonCol className="log-reg-holder">
            <IonRow className="ion-align-items-center full-row">
              <IonCol className="ion-reg-col">
                <IonRow className="ion-justify-content-center">
                  <IonCol className="width-content">
                    <PageLogo classNameFixed="logo-big" />
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" className="log-reg">
                    {children}
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
}
export { LogRegHeader, LogRegPageLayout };

